export default "__VITE_ASSET__iO78D0xA__"